import type { ApolloError } from '@apollo/client'
import { useQuery } from '@apollo/client'
import { useContext } from 'react'

import { Dispensary, GetDispensaryBySlugDocument } from '../../../graphql/search'
import { ApolloClientsContext } from '../../graphql/apollo'

export interface UseDispensaryOptions {
  slug?: string
}

export interface UseDispensary {
  loading: boolean
  data: Dispensary | null
  error?: ApolloError | Error
  called: boolean
}

export const useDispensary = ({ slug }: UseDispensaryOptions): UseDispensary => {
  const { comma: commaClient } = useContext(ApolloClientsContext)
  // resolve dispensary query synchronously when cached
  const {
    loading,
    data: responseData,
    error: queryError,
    called,
  } = useQuery(GetDispensaryBySlugDocument, {
    client: commaClient,
    skip: !slug,
    variables: {
      slug: slug ?? '',
    },
  })

  const error = !slug ? new Error('Invalid empty slug for dispensary.') : queryError
  const data = responseData?.dispensaryBySlug || null

  return {
    loading,
    data,
    error,
    called,
  }
}
